import React from 'react';
import { Link } from 'react-router-dom';
import StoreButtons from './StoreButtons';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img src="/assets/images/App-Icon.png" alt="SplitNest Logo" className="footer-logo" />
            <div>
              <h3 className="footer-title">
                <Link to="/">SplitNest</Link>
              </h3>
              <p className="footer-description">
                Professional expense management and bill splitting made simple. 
                Trusted by thousands of users worldwide for secure and transparent financial tracking.
              </p>
              <div className="footer-app-stores">
                <StoreButtons />
              </div>
            </div>
          </div>

          <div className="footer-links">
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms" className="footer-link">Terms of Service</Link>
            <Link to="/contact" className="footer-link">Contact Us</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; {currentYear} SplitNest. All rights reserved.</p>
          </div>
          <div className="footer-legal-disclaimer">
            <p>
              SplitNest is a financial management tool designed to help users track and split expenses. 
              We do not store or process actual financial transactions. Users are responsible for their own 
              financial decisions and compliance with applicable laws and regulations.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 